module.exports = __webpack_public_path__ + "img/world.d1cec69f.png";